import { type HttpClient } from '@/application/interfaces/http-client';

import { addProductsToCart } from './add-products-to-cart';
import addServicesToCart from './add-services-to-cart';
import changeItemShipment from './chage-item-shipment';
import changeShipmentModality from './change-shipment-modality';
import { getAvailability } from './get-availability';
import getCartShipments from './get-cart-shipments';
import getCartSummary from './get-cart-summary';
import { getSimilarProducts } from './get-similar-products';
import postCartAddress from './post-cart-address';
import { removeProductFromCart } from './remove-product-from-cart';

const cartService = (httpClient: HttpClient.Instance) => ({
  addProductsToCart: addProductsToCart(httpClient),
  addServicesToCart: addServicesToCart(httpClient),
  changeShipmentModality: changeShipmentModality(httpClient),
  getCartShipments: getCartShipments(httpClient),
  getAvailability: getAvailability(httpClient),
  getCartSummary: getCartSummary(httpClient),
  postCartAddress: postCartAddress(httpClient),
  removeProductFromCart: removeProductFromCart(httpClient),
  changeItemShipment: changeItemShipment(httpClient),
  getSimilarProducts: getSimilarProducts(httpClient),
});

export default cartService;
